import { memo, useMemo } from 'react'
import { TemplateTileColorSwatchWrapperProps } from '~/app/components/TemplateTile/components/TemplateTileColorSwatchWrapper/interface'
import { useI18nColorName } from '~/app/features/Gallery/hooks/useI18nColorName'
import { getColorSwatchColors } from '~/app/utils/getColorSwatchColors'
import { TemplateTileColorSwatch } from '@vp/ep-tiles'

export const TemplateTileColorSwatchWrapper = memo(({ colorSwatch, locale, isColorSwatchColorsSimilar }: TemplateTileColorSwatchWrapperProps) => {
  const { designId, colorComposition = [], isCustomColorVariation } = colorSwatch

  const { primaryColor, secondaryColor, tertiaryColor } = useMemo(
    () => getColorSwatchColors(colorComposition, isColorSwatchColorsSimilar),
    [colorComposition, isColorSwatchColorsSimilar],
  )

  const title = useI18nColorName(primaryColor, locale)
  const resolvedTertiaryColor = isCustomColorVariation ? tertiaryColor : undefined

  return (
    <TemplateTileColorSwatch
      accessibleText={title}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      tertiaryColor={resolvedTertiaryColor}
      value={designId}
    />
  )
})

TemplateTileColorSwatchWrapper.displayName = 'TemplateTileColorSwatchWrapper'
